import { z } from 'zod'

export const ADMINUSERLISTGET_CONTRACT_VERSION = '1.0.0' as const
export const adminUserListGetResponseSchema = z.unknown()
export type AdminUserListGetResponse = z.infer<typeof adminUserListGetResponseSchema>
